<template>
  <div>
    <div class="fm-flex fm-rela">
      <div
        style="
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          cursor: pointer;
        "
        @click="showPopover = true"
      ></div>
      <el-input
        :value="value ? value.name : ''"
        placeholder="请选择客户类型"
        style="width: 400px"
        suffix-icon="el-icon-arrow-right"
        readonly
      ></el-input>
    </div>
    <el-dialog
      title="选择客户类型"
      append-to-body
      modal-append-to-body
      width="700px"
      close-on-click-modal
      close-on-press-escape
      :visible.sync="showPopover"
    >
      <el-form inline :model="searchData">
        <el-form-item>
          <el-input
            placeholder="类型/备注"
            clearable
            prefix-icon="el-icon-search"
            v-model="searchData.searchInputValue"
            style="width: 250px"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="primary"
            size="mini"
            @click="changeAndSearch"
            :loading="searchLoading"
          >
            查询
          </el-button>
          <el-button
            icon="el-icon-refresh"
            size="mini"
            @click="resetAndSearch"
            :loading="searchLoading"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
      <el-form inline>
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-plus"
          @click="showEditDialog()"
          v-hasPermi="['customer:type:add']"
        >
          新增客户类型
        </el-button>
        <el-button
          icon="el-icon-delete"
          size="mini"
          plain
          type="danger"
          @click="select()"
        >
          清除已选
        </el-button>
      </el-form>
      <el-table
        v-loading="searchLoading"
        :data="searchRes && searchRes.data ? searchRes.data : []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        ref="refsTable"
        @sort-change="sortChange"
        max-height="600px"
      >
        <el-table-column
          prop="name"
          label="类型"
          width="150"
          align="left"
          header-align="center"
          sortable="custom"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="250"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-fmtype="scope.row.remark ? '' : 'warning'">{{
              scope.row.remark || "——"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.stop="select(scope.row)"
              type="text"
              icon="el-icon-thumb"
            >
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="hideclose"
        v-if="searchRes && searchRes.pageInfo"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchRes.pageInfo.page"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="searchRes.pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchRes.total"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog
      id="editDialog"
      :title="editInfo && editInfo.id ? '修改客户类型' : '新增客户类型'"
      width="500px"
      append-to-body
      modal-append-to-body
      close-on-click-modal
      close-on-press-escape
      :visible.sync="editDialogVisible"
    >
      <el-form
        :model="editInfo"
        label-position="right"
        label-width="100px"
        ref="editFormRef"
        :rules="{
          name: $ruleUtil.name('名称'),
          remark: $ruleUtil.simple({
            fieldName: '备注',
            required: false,
            max: 200,
          }),
        }"
        v-if="editInfo"
      >
        <el-form-item label="类型类型" prop="name">
          <el-input
            v-model="editInfo.name"
            placeholder="请输类型入类型"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            v-model="editInfo.remark"
            placeholder="请输入备注信息"
          ></el-input>
        </el-form-item>
        <el-form-item label="冻结状态" prop="frozen">
          <el-radio-group v-model="editInfo.frozen">
            <el-radio :label="false">
              <span v-fmtype="'success'">未冻结</span>
            </el-radio>
            <el-radio :label="true">
              <span v-fmtype="'danger'">已冻结</span>
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editInfo = null">取 消</el-button>
        <el-button type="primary" @click="edit">
          {{ editInfo && editInfo.id ? "修 改" : "新 增" }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebCustomerTypeSelectDialog",
  props: {
    value: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  computed: {
    editDialogVisible: {
      get() {
        return !!this.editInfo;
      },
      set(val) {
        if (!val) {
          this.editInfo = null;
        }
      },
    },
  },
  watch: {
    showPopover: {
      handler(newVal, val) {
        if (newVal) {
          this.search(true);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      showPopover: false,

      searchLoading: false,
      searchData: {
        searchInputValue: null,
      },

      searchParam: {
        quickSearchInfoList: [
          {
            columns: ["name", "remark"],
            quickSearchValue: null,
          },
        ],
        pageInfo: {
          page: 1,
          pageSize: 20,
        },
        sortInfo: null,
      },
      searchRes: {},

      editInfo: null,
    };
  },

  mounted() {},

  methods: {
    select(item) {
      this.$emit("select", item);
      this.showPopover = false;
    },
    handleSizeChange(val) {
      this.searchParam.pageInfo.pageSize = val;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    handleCurrentChange(val) {
      this.searchParam.pageInfo.page = val;
      this.search(false, {
        showSuccessMessage: true,
      });
    },
    changeAndSearch() {
      this.searchParam.quickSearchInfoList[0].quickSearchValue =
        this.searchData.searchInputValue;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    resetAndSearch() {
      this.searchData = this.$options.data().searchData;
      this.changeAndSearch();
    },
    sortChange(val) {
      this.searchParam.sortInfo =
        val && val.order
          ? {
              columnName: val.prop,
              order: val.order.replace("ending", "").toUpperCase(),
            }
          : null;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    async search(init, args) {
      this.searchLoading = true;
      if (init) {
        this.searchParam.pageInfo.page = 1;
      }
      let requestRes = await this.$api.customerType_findPageForSelect(
        this.searchParam,
        args
      );
      if (requestRes && requestRes.success) {
        this.searchRes = requestRes;
        this.searchRes.pageInfo = requestRes.pageInfo;
        this.$nextTick(() => {
          if (this.$refs.refsTable) {
            this.$refs.refsTable.doLayout();
          }
        });
      }
      if (requestRes.pageCount == 0) {
        this.searchRes = null;
      }
      setTimeout(() => {
        this.searchLoading = false;
      }, 200);
    },

    async showEditDialog() {
      this.editInfo = {
        name: null,
        remark: null,
        frozen: false,
      };
    },

    async edit() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.editInfo.id
          ? await this.$api.customerType_update(this.editInfo, {
              showLoading: true,
              loadingParam: {
                target: "#editDialog > *",
                lock: true,
                text: "修改中...",
              },
            })
          : await this.$api.customerType_addNew(this.editInfo, {
              showLoading: true,
              loadingParam: {
                target: "#editDialog > *",
                lock: true,
                text: "新增中...",
              },
            });
        if (requestRes && requestRes.success) {
          this.editInfo = null;
          this.search();
        }
      });
    },
  },
};
</script>

<style scoped>
/* 解决切换分页会出现一个关闭图标 */
.hideclose /deep/ .el-icon-circle-close {
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/CustomerTypeSelectDialog.vue